// JsFromRoutes CacheKey b9fa9aaaf33f3affc67b040709e73ccd
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/interest_submissions'),
}
